import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box } from '@mui/material';

function Logout() {
  const navigate = useNavigate()
  return (
    <Box sx={{
      textAlign: "center",
      padding: "20px"
    }}>
      <Typography sx={{
        fontSize: "24px",
        color: "#333",
        marginBottom: "20px",
      }}>You are logged out from the App Store</Typography>
      <Typography sx={{
        fontSize: "18px",
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer",
        marginTop: "20px",
        '&:hover': {
          textDecoration: "underline"
        }
      }} onClick={() => {
        navigate('/')
      }}>Click here to access the portal again</Typography>
    </Box>
  );
}

export default Logout;
